webpackJsonp([35783957827783],{

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(91)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(148);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(92);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(150);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(91);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(147);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(149);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(148);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(92);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(150);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(91);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(147);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(149);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(148);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(92);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(150);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(494);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(91);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(147);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(149);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(491);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(492);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(493);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(497);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(223);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(92);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(496);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(223);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactLink = function (_React$Component) {
	  _inherits(ContactLink, _React$Component);
	
	  function ContactLink(props) {
	    _classCallCheck(this, ContactLink);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { mounted: false };
	    return _this;
	  }
	
	  ContactLink.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ mounted: true });
	  };
	
	  ContactLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        link: true,
	        bordered: true,
	        href: this.state.mounted ? 'mailto:me%40gauti.info' : '#',
	        title: 'Contact Gowtham Selvaraj'
	      },
	      'Say Hello'
	    );
	  };
	
	  return ContactLink;
	}(_react2.default.Component);
	
	exports.default = ContactLink;
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n  ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: ', ';\n  '], ['\n    font-size: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Heading = _styledComponents2.default.h3(_templateObject, function (props) {
	  return props.inverse ? props.theme.white : props.theme.black;
	}, function (props) {
	  return props.bigger ? '1.85rem' : '1.35rem';
	}, _style.media.tablet(_templateObject2, function (props) {
	  return props.bigger ? '3rem' : '1.75rem';
	}));
	
	var H3 = function H3(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    Heading,
	    otherProps,
	    children
	  );
	};
	
	H3.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = H3;
	module.exports = exports['default'];

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n\n  ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: ', ';\n  '], ['\n    font-size: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Heading = _styledComponents2.default.h4(_templateObject, function (props) {
	  return props.light ? props.theme.gray : props.inverse ? props.theme.white : props.theme.black;
	}, function (props) {
	  return props.bigger ? '1.4rem' : props.big ? '1.3rem' : '1.25rem';
	}, _style.media.tablet(_templateObject2, function (props) {
	  return props.bigger ? '1.85rem' : props.big ? '1.65rem' : '1.4rem';
	}));
	
	var H4 = function H4(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    Heading,
	    otherProps,
	    children
	  );
	};
	
	H4.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = H4;
	module.exports = exports['default'];

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n\n  ', ';\n'], ['\n  color: ', ';\n  font-size: ', ';\n  line-height: 1.2;\n  margin: 0 0 10px;\n\n  ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    font-size: ', ';\n  '], ['\n    font-size: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Heading = _styledComponents2.default.h5(_templateObject, function (props) {
	  return props.light ? props.theme.gray : props.inverse ? props.theme.white : props.theme.black;
	}, function (props) {
	  return props.bigger ? '1.25rem' : props.big ? '1.15rem' : '1.1rem';
	}, _style.media.tablet(_templateObject2, function (props) {
	  return props.bigger ? '1.65rem' : props.big ? '1.5rem' : '1.25rem';
	}));
	
	var H5 = function H5(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    Heading,
	    otherProps,
	    children
	  );
	};
	
	H5.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = H5;
	module.exports = exports['default'];

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n'], ['\n  background-color: ', ';\n  min-height: 100vh;\n  position: relative;\n  overflow: hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  border: ', ';\n  border-radius: 50%;\n  height: 3rem;\n  position: absolute;\n  width: 3rem;\n  will-change: opacity, transform;\n'], ['\n  border: ', ';\n  border-radius: 50%;\n  height: 3rem;\n  position: absolute;\n  width: 3rem;\n  will-change: opacity, transform;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  min-height: 100vh;\n  position: relative;\n  z-index: 2;\n\n  ', ';\n'], ['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  min-height: 100vh;\n  position: relative;\n  z-index: 2;\n\n  ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    padding-bottom: 50px;\n  '], ['\n    padding-bottom: 50px;\n  ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 10px;\n  text-align: center;\n'], ['\n  padding: 10px;\n  text-align: center;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 2rem;\n  margin-top: 1.5rem;\n'], ['\n  margin-bottom: 2rem;\n  margin-top: 1.5rem;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  bottom: 10px;\n  display: none;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n\n  ', ';\n'], ['\n  bottom: 10px;\n  display: none;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n\n  ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n    display: inline-block;\n  '], ['\n    display: inline-block;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMotion = __webpack_require__(495);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _SocialLinks = __webpack_require__(98);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _ContactLink = __webpack_require__(94);
	
	var _ContactLink2 = _interopRequireDefault(_ContactLink);
	
	var _ScrollIndicator = __webpack_require__(240);
	
	var _ScrollIndicator2 = _interopRequireDefault(_ScrollIndicator);
	
	var _gautiSelvaraj = __webpack_require__(151);
	
	var _gautiSelvaraj2 = _interopRequireDefault(_gautiSelvaraj);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var leavingSpringConfig = { stiffness: 60, damping: 15 };
	
	var IntroWrap = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.black;
	});
	
	var Circle = _styledComponents2.default.div(_templateObject2, function (props) {
	  return '1px solid ' + props.theme.main;
	});
	
	var IntroContentWrapper = _styledComponents2.default.div(_templateObject3, _style.media.tablet(_templateObject4));
	
	var IntroContent = _styledComponents2.default.div(_templateObject5);
	
	var IntroText = _styledComponents2.default.div(_templateObject6);
	
	var ScrollIndicatorWrap = _styledComponents2.default.div(_templateObject7, _style.media.tablet(_templateObject8));
	
	var IntroSection = function (_Component) {
	  _inherits(IntroSection, _Component);
	
	  function IntroSection(props) {
	    _classCallCheck(this, IntroSection);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleMouseMove = function (_ref) {
	      var pageX = _ref.pageX,
	          pageY = _ref.pageY;
	
	      // Make sure the state is queued and not batched.
	      _this.setState(function () {
	        return {
	          mouse: [pageX - 25, pageY - 25],
	          now: 't' + Date.now()
	        };
	      });
	    };
	
	    _this.handleTouchMove = function (e) {
	      _this.handleMouseMove(e.touches[0]);
	    };
	
	    _this.willLeave = function (styleCell) {
	      return _extends({}, styleCell.style, {
	        opacity: (0, _reactMotion.spring)(0, leavingSpringConfig),
	        scale: (0, _reactMotion.spring)(2, leavingSpringConfig)
	      });
	    };
	
	    _this.scrollToNextPage = function () {
	      window.scroll({ top: _this.parentRef.offsetHeight, behavior: 'smooth' });
	    };
	
	    _this.state = { mouse: [], now: 't' + 0 };
	    return _this;
	  }
	
	  IntroSection.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        _state$mouse = _state.mouse,
	        mouseX = _state$mouse[0],
	        mouseY = _state$mouse[1],
	        now = _state.now;
	
	    var styles = mouseX == null ? [] : [{
	      key: now,
	      style: {
	        opacity: (0, _reactMotion.spring)(1),
	        scale: (0, _reactMotion.spring)(0),
	        x: (0, _reactMotion.spring)(mouseX),
	        y: (0, _reactMotion.spring)(mouseY)
	      }
	    }];
	
	    return _react2.default.createElement(
	      _reactMotion.TransitionMotion,
	      { willLeave: this.willLeave, styles: styles },
	      function (circles) {
	        return _react2.default.createElement(
	          IntroWrap,
	          {
	            onMouseMove: _this2.handleMouseMove,
	            onTouchMove: _this2.handleTouchMove,
	            onScroll: _this2.handleScroll,
	            innerRef: function innerRef(ele) {
	              return _this2.parentRef = ele;
	            }
	          },
	          circles.map(function (_ref2) {
	            var key = _ref2.key,
	                _ref2$style = _ref2.style,
	                opacity = _ref2$style.opacity,
	                scale = _ref2$style.scale,
	                x = _ref2$style.x,
	                y = _ref2$style.y;
	            return _react2.default.createElement(Circle, {
	              key: key,
	              style: {
	                opacity: opacity,
	                transform: 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')',
	                WebkitTransform: 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ')'
	              }
	            });
	          }),
	          _react2.default.createElement(
	            IntroContentWrapper,
	            null,
	            _react2.default.createElement(
	              IntroContent,
	              { itemScope: true, itemType: 'http://schema.org/Person' },
	              _react2.default.createElement('img', {
	                src: _gautiSelvaraj2.default,
	                width: 250,
	                itemProp: 'image',
	                alt: 'Gowtham Selvaraj (Gauti)'
	              }),
	              _react2.default.createElement(
	                IntroText,
	                null,
	                _react2.default.createElement(
	                  _H2.default,
	                  { inverse: true },
	                  'Hi, I\'m ',
	                  _react2.default.createElement(
	                    'span',
	                    { itemProp: 'name' },
	                    'Gowtham Selvaraj'
	                  ),
	                  ' (',
	                  _react2.default.createElement(
	                    'span',
	                    { itemProp: 'additionalName' },
	                    'Gauti'
	                  ),
	                  '),'
	                ),
	                _react2.default.createElement(
	                  _P2.default,
	                  { inverse: true, bigger: true },
	                  'a',
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { itemProp: 'jobTitle' },
	                    'Full Stack JavaScript Engineer'
	                  ),
	                  ' ',
	                  'based in',
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      itemProp: 'address',
	                      itemScope: true,
	                      itemType: 'http://schema.org/PostalAddress'
	                    },
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { itemProp: 'addressLocality' },
	                      'Christchurch'
	                    ),
	                    ',',
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { itemProp: 'addressCountry' },
	                      'New Zealand'
	                    ),
	                    '.'
	                  )
	                )
	              ),
	              _react2.default.createElement(_ContactLink2.default, null),
	              _react2.default.createElement(_SocialLinks2.default, null),
	              _react2.default.createElement(
	                ScrollIndicatorWrap,
	                null,
	                _react2.default.createElement(_ScrollIndicator2.default, { inverse: true, onClick: _this2.scrollToNextPage })
	              )
	            )
	          )
	        );
	      }
	    );
	  };
	
	  return IntroSection;
	}(_react.Component);
	
	exports.default = IntroSection;
	module.exports = exports['default'];

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  color: ', ';\n  padding: 75px 10px;\n'], ['\n  background-color: ', ';\n  color: ', ';\n  padding: 75px 10px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin: 0 auto 20px;\n  max-width: 800px;\n'], ['\n  margin: 0 auto 20px;\n  max-width: 800px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 0 auto;\n  max-width: 800px;\n\n  a {\n    color: ', ';\n  }\n\n  p {\n    margin-bottom: 20px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n'], ['\n  margin: 0 auto;\n  max-width: 800px;\n\n  a {\n    color: ', ';\n  }\n\n  p {\n    margin-bottom: 20px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	var _H = __webpack_require__(18);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _H3 = __webpack_require__(234);
	
	var _H4 = _interopRequireDefault(_H3);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SkillsWrap = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.main;
	}, function (props) {
	  return props.theme.white;
	});
	
	var Headings = _styledComponents2.default.div(_templateObject2);
	
	var MainContent = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.white;
	});
	
	var SkillsSection = function (_Component) {
	  _inherits(SkillsSection, _Component);
	
	  function SkillsSection() {
	    _classCallCheck(this, SkillsSection);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SkillsSection.prototype.render = function render() {
	    return _react2.default.createElement(
	      SkillsWrap,
	      null,
	      _react2.default.createElement(
	        Headings,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          { big: true, inverse: true },
	          'Hi again, Thanks for scrolling down to know more about me.'
	        )
	      ),
	      _react2.default.createElement(
	        MainContent,
	        null,
	        _react2.default.createElement(
	          _P2.default,
	          { big: true, inverse: true },
	          'My journey with JavaScript started in 2010 when I was at my university doing my bachelors in Information and Communication Technology. Since then I have been working with JavaScript delivering',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://developer.mozilla.org/en-US/docs/Web/Accessibility',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Accessible Web Apps'
	            },
	            'accessible'
	          ),
	          ' ',
	          'and',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://en.wikipedia.org/wiki/Progressive_Web_Apps',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Progressive Web Apps'
	            },
	            'progressive'
	          ),
	          ' ',
	          'web apps.'
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { big: true, inverse: true },
	          'I am an optimistic level-headed person who proportionates smartness and hard work. I love to solve problems and I can learn & adapt to new technologies quickly. I have worked for both startups & corporate companies and have valuable experience from both environments. I blend in with teams easily and I look for a good relationship with people I come across. I am always open to discussion & feedback and I update myself regularly.'
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { big: true, inverse: true },
	          'I love working with',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://reactjs.org/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'React JavaScript Framework'
	            },
	            'React'
	          ),
	          ',',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://vuejs.org/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Vue JavaScript Framework'
	            },
	            'Vue.js'
	          ),
	          ' ',
	          'and',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://nodejs.org/en/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Node.js'
	            },
	            'Node.js'
	          ),
	          '. I have also worked extensively with',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://www.ruby-lang.org/en/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Ruby Programming Language'
	            },
	            'Ruby'
	          ),
	          ' ',
	          'and',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://rubyonrails.org/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Ruby on Rails'
	            },
	            'Rails'
	          ),
	          '. I believe in test-driven development & automation. I automate most of my workflow using',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://webpack.js.org/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Webpack Module Bundler '
	            },
	            'Webpack'
	          ),
	          ',',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://docs.npmjs.com/misc/scripts',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'npm-scripts'
	            },
	            'npm-scripts'
	          ),
	          ',',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://gruntjs.com/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Grunt - Task Runner'
	            },
	            'grunt'
	          ),
	          ', and',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://gulpjs.com/',
	              target: '_blank',
	              rel: 'noopener',
	              title: 'Gulp - Automate your workflow'
	            },
	            'gulp'
	          ),
	          '. I am familiar with Photoshop, Illustrator and cloud platforms like AWS, Google Cloud Platform and Heroku.'
	        )
	      )
	    );
	  };
	
	  return SkillsSection;
	}(_react.Component);
	
	exports.default = SkillsSection;
	module.exports = exports['default'];

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.List = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  margin: ', ';\n'], ['\n  display: ', ';\n  margin: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = exports.List = _styledComponents2.default.li(_templateObject, function (props) {
	  return props.inline ? 'inline-block' : 'block';
	}, function (props) {
	  return props.inline ? '2px .5rem' : '.5rem 0';
	});
	
	var LI = function LI(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    List,
	    otherProps,
	    children
	  );
	};
	
	LI.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = LI;

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  &:after {\n    background-color: rgba(0, 0, 0, 0.05);\n    bottom: 0;\n    content: \'\';\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%;\n  }\n'], ['\n  &:after {\n    background-color: rgba(0, 0, 0, 0.05);\n    bottom: 0;\n    content: \'\';\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  bottom: 0;\n  left: 0;\n  padding: 35px 10px 10px;\n  position: absolute;\n  right: 0;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n'], ['\n  background: ', ';\n  bottom: 0;\n  left: 0;\n  padding: 35px 10px 10px;\n  position: absolute;\n  right: 0;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 15px auto;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  ', ' ', '\n\n  a {\n    display: block;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 25px;\n      }\n    }\n  }\n'], ['\n  margin: 15px auto;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  ', ' ', '\n\n  a {\n    display: block;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 25px;\n      }\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n          max-width: 350px;\n        '], ['\n          max-width: 350px;\n        ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    margin: 0 0.5%;\n    width: ', ';\n  '], ['\n    margin: 0 0.5%;\n    width: ', ';\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _style = __webpack_require__(7);
	
	var _H = __webpack_require__(18);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _ResponsiveImg = __webpack_require__(34);
	
	var _ResponsiveImg2 = _interopRequireDefault(_ResponsiveImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectImg = _styledComponents2.default.div(_templateObject);
	
	var ProjectCopy = _styledComponents2.default.div(_templateObject2, function (props) {
	  return 'linear-gradient(transparent, rgba(0, 0, 0, .7), ' + props.theme.black + ')';
	});
	
	var ProjectWrap = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.portrait ? (0, _styledComponents.css)(_templateObject4) : '';
	}, _style.media.desktop(_templateObject5, function (props) {
	  return props.portrait ? '24%' : '49%';
	}), ProjectCopy);
	
	var Project = function Project(_ref) {
	  var link = _ref.link,
	      title = _ref.title,
	      description = _ref.description,
	      image = _ref.image,
	      portrait = _ref.portrait;
	  return _react2.default.createElement(
	    ProjectWrap,
	    { portrait: portrait },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: link, title: 'Visit ' + title + ' Project Page' },
	      _react2.default.createElement(
	        ProjectImg,
	        null,
	        _react2.default.createElement(_ResponsiveImg2.default, { src: image, alt: description })
	      ),
	      _react2.default.createElement(
	        ProjectCopy,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          { inverse: true },
	          title
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { inverse: true },
	          description
	        )
	      )
	    )
	  );
	};
	
	Project.propTypes = {
	  link: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.string.isRequired
	};
	
	exports.default = Project;
	module.exports = exports['default'];

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  margin: 5px auto;\n  padding: 10px;\n  height: 100px;\n  width: 100px;\n'], ['\n  align-items: center;\n  background-color: ', ';\n  border-radius: 50%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  margin: 5px auto;\n  padding: 10px;\n  height: 100px;\n  width: 100px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: block;\n  flex-grow: 1;\n  padding: 50px 20px 10px;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n'], ['\n  display: block;\n  flex-grow: 1;\n  padding: 50px 20px 10px;\n  text-align: left;\n  transition: padding 0.35s;\n\n  p {\n    margin: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  box-sizing: border-box;\n  display: flex;\n  margin: 15px auto;\n  max-width: 350px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  ', ' &:before {\n    background-image: ', ';\n    border-radius: 0 0 100% 100%;\n    content: \'\';\n    height: 130px;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n  }\n\n  a {\n    display: block;\n    position: relative;\n    text-decoration: none;\n    width: 100%;\n    z-index: 2;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 40px;\n      }\n    }\n  }\n'], ['\n  background-color: ', ';\n  box-sizing: border-box;\n  display: flex;\n  margin: 15px auto;\n  max-width: 350px;\n  position: relative;\n  text-align: center;\n  width: 100%;\n\n  ', ' &:before {\n    background-image: ', ';\n    border-radius: 0 0 100% 100%;\n    content: \'\';\n    height: 130px;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n  }\n\n  a {\n    display: block;\n    position: relative;\n    text-decoration: none;\n    width: 100%;\n    z-index: 2;\n\n    &:hover,\n    &:focus {\n      ', ' {\n        padding-bottom: 20px;\n        padding-top: 40px;\n      }\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    margin: 0 0.5%;\n    width: 29%;\n  '], ['\n    margin: 0 0.5%;\n    width: 29%;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _style = __webpack_require__(7);
	
	var _H = __webpack_require__(18);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _ResponsiveImg = __webpack_require__(34);
	
	var _ResponsiveImg2 = _interopRequireDefault(_ResponsiveImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ProjectImg = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.projectNoImage;
	});
	
	var ProjectCopy = _styledComponents2.default.div(_templateObject2);
	
	var ProjectWrap = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.theme.projectNoImage;
	}, _style.media.desktop(_templateObject4), function (props) {
	  return 'url("data:image/svg+xml,%3Csvg width=\'6\' height=\'6\' viewBox=\'0 0 6 6\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'%23' + props.theme.projectNoImagePattern + '\' fill-opacity=\'0.25\' fill-rule=\'evenodd\'%3E%3Cpath d=\'M5 0h1L0 6V5zM6 5v1H5z\'/%3E%3C/g%3E%3C/svg%3E")';
	}, ProjectCopy);
	
	var ProjectWithNoImage = function ProjectWithNoImage(_ref) {
	  var link = _ref.link,
	      title = _ref.title,
	      description = _ref.description,
	      image = _ref.image;
	  return _react2.default.createElement(
	    ProjectWrap,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: link, title: 'Visit ' + title + ' Project Page' },
	      _react2.default.createElement(
	        ProjectImg,
	        null,
	        _react2.default.createElement(_ResponsiveImg2.default, { src: image, alt: description })
	      ),
	      _react2.default.createElement(
	        ProjectCopy,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          { inverse: true },
	          title
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { inverse: true },
	          description
	        )
	      )
	    )
	  );
	};
	
	ProjectWithNoImage.propTypes = {
	  link: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.string.isRequired
	};
	
	exports.default = ProjectWithNoImage;
	module.exports = exports['default'];

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: ', ';\n  text-align: center;\n'], ['\n  padding: ', ';\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-bottom: 25px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align: center;\n  width: 100%;\n\n  ', ';\n'], ['\n  align-items: center;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-bottom: 25px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align: center;\n  width: 100%;\n\n  ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    flex-wrap: nowrap;\n  '], ['\n    flex-wrap: nowrap;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _style = __webpack_require__(7);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _H3 = __webpack_require__(50);
	
	var _H4 = _interopRequireDefault(_H3);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _Project = __webpack_require__(95);
	
	var _Project2 = _interopRequireDefault(_Project);
	
	var _ProjectWithNoImage = __webpack_require__(96);
	
	var _ProjectWithNoImage2 = _interopRequireDefault(_ProjectWithNoImage);
	
	var _compareMovies = __webpack_require__(69);
	
	var _compareMovies2 = _interopRequireDefault(_compareMovies);
	
	var _nagMe = __webpack_require__(70);
	
	var _nagMe2 = _interopRequireDefault(_nagMe);
	
	var _react3 = __webpack_require__(152);
	
	var _react4 = _interopRequireDefault(_react3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Headings = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.projectPage ? '0 10px 20px' : '40px 10px 20px';
	});
	
	var Projects = _styledComponents2.default.div(_templateObject2, _style.media.desktop(_templateObject3));
	
	exports.default = function (_ref) {
	  var projectPage = _ref.projectPage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      Headings,
	      { projectPage: projectPage },
	      projectPage ? _react2.default.createElement(
	        _H2.default,
	        { bigger: true },
	        'Projects'
	      ) : _react2.default.createElement(
	        _H4.default,
	        { bigger: true },
	        'Projects'
	      ),
	      _react2.default.createElement(
	        _P2.default,
	        { bigger: true },
	        'A collection of my open-source works and recent projects'
	      )
	    ),
	    _react2.default.createElement(
	      Projects,
	      null,
	      _react2.default.createElement(_ProjectWithNoImage2.default, {
	        link: '/projects/react-shorten',
	        title: 'React Shorten',
	        description: 'React component to shorten text',
	        image: _react4.default
	      }),
	      _react2.default.createElement(_Project2.default, {
	        link: '/projects/compare-movies',
	        title: 'Compare Movies',
	        description: 'Compare Movies and TV Shows Instantly',
	        image: _compareMovies2.default
	      }),
	      _react2.default.createElement(_Project2.default, {
	        portrait: true,
	        link: '/projects/nag-me',
	        title: 'Nag Me',
	        description: 'Browser extension to nag users',
	        image: _nagMe2.default
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\tfrom {\n    opacity: 1;\n\t\ttop: 0;\n\t}\n\n\tto {\n    opacity: .5;\n\t\ttop: 12px;\n\t}\n'], ['\n\tfrom {\n    opacity: 1;\n\t\ttop: 0;\n\t}\n\n\tto {\n    opacity: .5;\n\t\ttop: 12px;\n\t}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  background-color: transparent;\n  border-color: ', ';\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 0.65rem;\n  cursor: pointer;\n  display: inline-block;\n  height: 30px;\n  position: relative;\n  width: 18px;\n\n  &:before {\n    animation: ', ' 1.5s ease-in-out infinite;\n    color: ', ';\n    content: \'.\';\n    left: 50%;\n    line-height: 3px;\n    position: absolute;\n    top: 0;\n    transform: translateX(-50%);\n  }\n\n  &:hover,\n  &:focus {\n    background-color: ', ';\n    border-color: ', ';\n  }\n'], ['\n  background-color: transparent;\n  border-color: ', ';\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 0.65rem;\n  cursor: pointer;\n  display: inline-block;\n  height: 30px;\n  position: relative;\n  width: 18px;\n\n  &:before {\n    animation: ', ' 1.5s ease-in-out infinite;\n    color: ', ';\n    content: \'.\';\n    left: 50%;\n    line-height: 3px;\n    position: absolute;\n    top: 0;\n    transform: translateX(-50%);\n  }\n\n  &:hover,\n  &:focus {\n    background-color: ', ';\n    border-color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var mouseScroll = (0, _styledComponents.keyframes)(_templateObject);
	
	var ScrollIndicator = _styledComponents2.default.button(_templateObject2, function (props) {
	  return props.inverse ? props.theme.white : props.theme.black;
	}, mouseScroll, function (props) {
	  return props.inverse ? props.theme.white : props.theme.black;
	}, function (props) {
	  return props.theme.main;
	}, function (props) {
	  return props.theme.main;
	});
	
	exports.default = function (props) {
	  return _react2.default.createElement(ScrollIndicator, _extends({}, props, { title: 'Scroll To Next Page' }));
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UL = __webpack_require__(29);
	
	var _UL2 = _interopRequireDefault(_UL);
	
	var _LI = __webpack_require__(28);
	
	var _LI2 = _interopRequireDefault(_LI);
	
	var _Icon = __webpack_require__(52);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _UL2.default,
	    { inverse: true, inline: true },
	    _react2.default.createElement(
	      _LI2.default,
	      { inline: true },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          link: true,
	          bordered: true,
	          inverse: true,
	          circle: true,
	          target: '_blank',
	          rel: 'noopener',
	          href: 'https://github.com/gautiselvaraj',
	          title: 'Gowtham Selvaraj\'s Github Account'
	        },
	        _react2.default.createElement(_Icon2.default, { big: true, github: true, 'aria-label': 'Gowtham Selvaraj\'s Github Account' })
	      )
	    ),
	    _react2.default.createElement(
	      _LI2.default,
	      { inline: true },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          link: true,
	          bordered: true,
	          inverse: true,
	          circle: true,
	          target: '_blank',
	          rel: 'noopener',
	          href: 'https://www.linkedin.com/in/gautiselvaraj/',
	          title: 'Gowtham Selvaraj\'s LinkedIn Page'
	        },
	        _react2.default.createElement(_Icon2.default, { big: true, linkedin: true, 'aria-label': 'Gowtham Selvaraj\'s LinkedIn Page' })
	      )
	    ),
	    _react2.default.createElement(
	      _LI2.default,
	      { inline: true },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          link: true,
	          bordered: true,
	          inverse: true,
	          circle: true,
	          target: '_blank',
	          rel: 'noopener',
	          href: 'https://twitter.com/gautiselvaraj',
	          title: 'Gowtham Selvaraj\'s Twitter Account'
	        },
	        _react2.default.createElement(_Icon2.default, { big: true, twitter: true, 'aria-label': 'Gowtham Selvaraj\'s Twitter Account' })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.2;\n  ', ';\n'], ['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.2;\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = _styledComponents2.default.ul(_templateObject, function (props) {
	  return props.inverse ? '#ffffff' : '#000000';
	}, function (props) {
	  return props.inline ? 'padding-left: 0' : '';
	});
	
	var UL = function UL(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    List,
	    otherProps,
	    children
	  );
	};
	
	UL.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = UL;
	module.exports = exports['default'];

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/compare-movies.fb04962c.jpg";

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nag-me.7c04e4a1.jpg";

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IntroSection = __webpack_require__(236);
	
	var _IntroSection2 = _interopRequireDefault(_IntroSection);
	
	var _SkillsSection = __webpack_require__(237);
	
	var _SkillsSection2 = _interopRequireDefault(_SkillsSection);
	
	var _ProjectComponents = __webpack_require__(97);
	
	var _ProjectComponents2 = _interopRequireDefault(_ProjectComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_IntroSection2.default, null),
	    _react2.default.createElement(_SkillsSection2.default, null),
	    _react2.default.createElement(_ProjectComponents2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ed159232ab3a77db6fab.js